module.exports = __webpack_public_path__ + "static/19-518069428b34e7aadd07e2ac4f67b395.jpg";